const state = () => ({
    switchLeftMenuMyAccount: false,
});

const getters = {

}

const actions = {

}

const mutations = {
    setSwitchLeftMenuMyAccount(state, payload) {
        state.switchLeftMenuMyAccount = payload;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}; 


// WEBPACK FOOTER //
// ./src/store/modules/layout.js